import React, { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "hi" : "en")), []);
  const t = useCallback((obj) => (obj && typeof obj === "object" ? obj[lang] ?? obj.en : obj), [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
